import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import TransactionPage from "./pages/transactionPage";
import TransactionSuccessPage from "./pages/transactionSuccessPage";
import TransactionErrorPage from "./pages/transactionErrorPage";
import VerificationPage from "./pages/verificationPage";
import RFPLitePage from "./pages/RFPLitePage";
import RFPLiteSuccessPage from "./pages/RFPLiteSuccessPage";
import RFPErrorPage from "./pages/RFPErrorPage";
import InfoPage from "./pages/infoPage"
import { IBT_THEME } from "./constants/colors";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import configureStore from "./configureStore";
import { Layout } from "./components/Layout";
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

// Create redux store with history
const store = configureStore();

if ( process.env.REACT_APP_DATADOG_APPLICATION_ID ) {
  datadogRum.init({
    applicationId:  process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken:    process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site:           process.env.REACT_APP_DATADOG_SITE,
    service:        process.env.REACT_APP_DATADOG_SERVICE,
    env:            process.env.REACT_APP_DATADOG_ENV,
    version:        process.env.REACT_APP_DATADOG_VERSION,
    sampleRate: 100,
    trackInteractions: true
  });

  if ( process.env.REACT_APP_DATADOG_SESSION_RECORD ) {
    datadogRum.startSessionReplayRecording();
  }
}

datadogLogs.init({
  applicationId:  process.env.REACT_APP_DATADOG_APPLICATION_ID,
  clientToken:    process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  site:           process.env.REACT_APP_DATADOG_SITE,
  service:        process.env.REACT_APP_DATADOG_SERVICE,
  env:            process.env.REACT_APP_DATADOG_ENV,
  version:        process.env.REACT_APP_DATADOG_VERSION,
  forwardErrorsToLogs: true,
  sampleRate: 100,
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={IBT_THEME}>
        <Layout>
          <BrowserRouter>
            <Routes>
              <Route path="/transaction" element={<TransactionPage />} />
              <Route path="/transactionError" element={<TransactionErrorPage />} />
              <Route path="/verification" element={<VerificationPage />} />
              <Route path="/transactionSuccess" element={<TransactionSuccessPage />} />
              <Route path="/rfp" element={<RFPLitePage />} />
              <Route path="/rfpSuccess" element={<RFPLiteSuccessPage />} />
              <Route path="/rfpError" element={<RFPErrorPage />} />
              <Route path="/rfpError/:errorId" element={<RFPErrorPage />} />
              { process.env.REACT_APP_INFO_ENABLED === 'true' && <Route path="/info" element={<InfoPage />} /> }
            </Routes>
          </BrowserRouter>
        </Layout>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
